<template>
  <nav class="my-6 p-4 bg-muted/50 border border-border rounded-lg" aria-label="Table of contents">
    <h2 class="text-base font-semibold text-foreground mb-3 flex items-center gap-2">
      <Icon name="tabler:list" size="18" aria-hidden="true" />
      {{ title }}
    </h2>
    <ol class="list-decimal list-inside space-y-1.5 text-sm">
      <li v-for="(item, index) in items" :key="item.id || index">
        <a
          :href="item.href"
          class="text-muted-foreground hover:text-foreground transition-colors"
        >
          {{ item.text }}
        </a>
      </li>
    </ol>
  </nav>
</template>

<script setup lang="ts">
interface TableOfContentsItem {
  text: string;
  href: string;
  id?: string;
}

interface Props {
  title?: string;
  items: TableOfContentsItem[];
}

withDefaults(defineProps<Props>(), {
  title: 'Table of Contents',
});
</script>
